import * as helpers from '../plugins/timer/helpers';
import { connect } from 'vuex-connect';
import RedirectionNotification from '@/launcher/components/shared/notifications/RedirectionNotification';
import { REDIRECTION_TIMEOUT } from '../constants';
import { i18n } from '@/setup/i18n.js';

export const redirectToLauncherWithNotification = ({ commit, dispatch, getters }) => {
  helpers.setTimeout(() => {
    dispatch('startLauncher');
    dispatch('removeAllNotifications');
  }, { name: 'redirectToLauncher', delay: REDIRECTION_TIMEOUT });
  dispatch('replaceNotification', {
    props: {
      timeoutName: 'redirectToLauncher',
    },
    delay: null,
    component: connect({
      stateToProps: {
        remaining: state => state.timeouts.redirectToLauncher
          ? String(state.timeouts.redirectToLauncher.remaining / 1000)
          : '0',
      },
    })('RedirectionNotification', RedirectionNotification),
  });
};

export const notifyTimesUp = ({ commit, dispatch, getters }) => {
  dispatch('replaceNotification', {
    props: {
      message: i18n.t('Time is up!'),
      sound: 'error',
    },
  });
};

export const notifyTimesAdded = ({ commit, dispatch, getters }, time) => {
  dispatch('addNotification', {
    delay: 10000,
    props: {
      type: 'timeadded',
      message: i18n.t('{count} min were added to your station!', { count: Math.round(time / 60000) }),
    },
  });
};

export const notifySafetyModeOn = ({ commit, dispatch, getters }, time) => {
  dispatch('removeAllNotifications');
  dispatch('addNotification', {
    delay: 10000,
    props: {
      type: '',
      message: i18n.t('Connection unstable. You can keep playing but some functionalities might be unavailable.'),
    },
  });
};
export const notifySafetyModeOff = ({ commit, dispatch, getters }, time) => {
  dispatch('removeAllNotifications');
  dispatch('addNotification', {
    delay: 10000,
    props: {
      type: '',
      message: i18n.t('Reconnected. All functionality restored.'),
    },
  });
};
